var t = /* @__PURE__ */ ((e) => (e[e.unselected = 0] = "unselected", e[e.selected = 1] = "selected", e[e.indeterminate = 2] = "indeterminate", e))(t || {});
export {
  t as SELECT_STATES
};
//# sourceMappingURL=index.es75.js.map
